import React, { useContext } from "react";
import { ExclamationIcon } from "@heroicons/react/outline";
import axios from "axios";
import backendService from "../services.js/backendService";
import { SocketContext } from "../services.js/socket";



function ConfirmationDialogBox({
  openDeleteMessageAlert,
  getDeleteMessage,
  getForwardMessage,
  id,
  reciever,
}) {
  const socket = useContext(SocketContext);
  const [loading, setLoading] = React.useState(false);
  const deleteMessage = async () => {
    try {
      setLoading(true);
      const res = await axios.delete(`${process.env.REACT_APP_URL}/deletemessage/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": backendService.getToken(),
        },
      });
      socket.emit("deleteMessage", {
        receiverId: reciever,
        messageId: id,
      });

      getForwardMessage(res);
      getDeleteMessage(id);
      setLoading(false);
      openDeleteMessageAlert(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
      {/* This element is to trick the browser into centering the modal contents. */}
      <span
        className="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
      >
        &#8203;
      </span>
      <div className="relative inline-block bg-background rounded-lg text-left overflow-hidden shadow-md shadow-black transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
        <div className="bg-background px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div className="sm:flex sm:items-start ">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <ExclamationIcon
                className="h-8 w-8 text-red"
                aria-hidden="true"
              />
            </div>
            <div className="mt-3 sm:mt-0 sm:ml-4 sm:text-left">
              <h3 className="text-lg leading-6 font-robo  text-red">
                Delete Message
              </h3>
              <div className="mt-2">
                <p className="text-sm text-primary font-robo ">
                  Are you sure you want to delete this message? This action
                  cannot be undone.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-background px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button
            type="button"
            disabled={loading}
            className="bg-red border-[1px] ml-4 border-red mt-1 hover:bg-palette_color2 text-white hover:text-red  font-robo uppercase text-md  px-6 py-1 rounded shadow-sm hover:border hover:border-red  ease-linear transition-all duration-500"
            onClick={async () => {
              await deleteMessage();
            }}
          >
            Delete
          </button>
          <button
            type="button"
            className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-6 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
            onClick={() => openDeleteMessageAlert(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationDialogBox;
